import React from "react";
import { toLocalDateString } from "@hex-insights/core";
import {
	OrderDirection,
	SchoolAttendanceRecordListForCourseAttendanceQuery,
	SchoolAttendanceRecordOrderField,
	Student,
	StudentFilterInput,
	useSchoolAttendanceRecordListForCourseAttendanceQuery,
} from "../../../Utilities";

export function useStudentSchoolAttendanceRecordOnDate(
	studentFilters: StudentFilterInput,
	date = toLocalDateString(new Date()),
	skip = false,
) {
	const {
		loading,
		data: schoolAttendanceRecordData,
		error,
	} = useSchoolAttendanceRecordListForCourseAttendanceQuery({
		variables: {
			filters: {
				attendanceDateEQ: date,
				student: [studentFilters],
			},
			order: { field: SchoolAttendanceRecordOrderField.CreatedAt, direction: OrderDirection.Desc },
		},
		fetchPolicy: "network-only",
		skip,
	});
	const studentAttendanceRecordMap = React.useMemo(() => {
		const map: Record<
			Student["id"],
			SchoolAttendanceRecordListForCourseAttendanceQuery["schoolAttendanceRecordConnection"]["edges"][0]["node"]
		> = {};

		if (!schoolAttendanceRecordData) {
			return map;
		}

		for (let i = 0; i < schoolAttendanceRecordData.schoolAttendanceRecordConnection.edges.length; i++) {
			const record = schoolAttendanceRecordData.schoolAttendanceRecordConnection.edges[i].node;
			if (map[record.studentID]) {
				continue;
			}

			map[record.studentID] = record;
		}

		return map;
	}, [schoolAttendanceRecordData]);

	return { loading, error, schoolAttendanceRecordData, studentAttendanceRecordMap };
}
